/**
* Concern Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Concern Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {

    className: 'concern-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.concern-marquee__marquee' ).length ) {
        $( '.concern-marquee__marquee' ).each( function( key, component ) {
          new Splide( component, {
            type: 'loop',
            pagination: false,
            autoWidth: true,
            drag: false,
            gap: '-1.25rem',
            arrows: false,
            autoScroll: {
              pauseOnHover: false,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'concern-marquee', COMPONENT );
} )( app );
